/**
 * @generated SignedSource<<9d79180ef50fa9f9e1dd6a3f6031a46d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type usePhaseDeliverablePreflightAssetsQuery$variables = {
  projectId: string;
};
export type usePhaseDeliverablePreflightAssetsQuery$data = {
  readonly viewer: {
    readonly project: {
      readonly clientAssets: ReadonlyArray<{
        readonly id: string;
        readonly assetType: string;
        readonly name: string;
        readonly status: string;
        readonly archived: boolean;
        readonly psaTaskId: string | null;
      }> | null;
    } | null;
  } | null;
};
export type usePhaseDeliverablePreflightAssetsQuery = {
  variables: usePhaseDeliverablePreflightAssetsQuery$variables;
  response: usePhaseDeliverablePreflightAssetsQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "projectId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "internalId",
    "variableName": "projectId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "ClientAsset",
  "kind": "LinkedField",
  "name": "clientAssets",
  "plural": true,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "assetType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "archived",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "psaTaskId",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "usePhaseDeliverablePreflightAssetsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "ProjectType",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": [
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "usePhaseDeliverablePreflightAssetsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "ProjectType",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "b2cbb3f5e428a49c0229c3527461f061",
    "id": null,
    "metadata": {},
    "name": "usePhaseDeliverablePreflightAssetsQuery",
    "operationKind": "query",
    "text": "query usePhaseDeliverablePreflightAssetsQuery(\n  $projectId: ID!\n) {\n  viewer {\n    project(internalId: $projectId) {\n      clientAssets {\n        id\n        assetType\n        name\n        status\n        archived\n        psaTaskId\n      }\n      id\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "e058aadd1db3d6ee750ca44f707fc3fa";

export default node;
